export class DialogModelWarehouseGenericConfirm{
    constructor(
      public message: any,
      public acceptButtonName: any,
      public denyButtonName: any
    ) {}
  }
  